// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"30":"feedback","150":"amap","550":"msg","641":"bing"}[chunkId] + "." + {"30":"9b2641ae","150":"fda962a3","550":"24ce7b9e","641":"8e576b82"}[chunkId] + ".chunk.css";
};